import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import Side from './side';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card } from 'react-bootstrap';
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

import * as serviceWorker from './serviceWorker';

class Main extends React.Component {
    render() {
        return (
            <div className="main">
            </div>
        );
    }

}

const FooterPage = () => {
  return (
    <MDBFooter color="blue" className="font-small pt-4 mt-4">
      <MDBContainer fluid className="text-center text-md-left">
        <MDBRow>
          <MDBCol md="6">
            <h5 className="title">Contact Me</h5>
            <p>
                austinwong95 at hotmail dot com
            </p>
          </MDBCol>
          <MDBCol md="6">
            <h5 className="title">Links</h5>
            <ul>
              <li className="list-unstyled">
                <a href="ziaowang.me">Personal Life</a>
              </li>
              <li className="list-unstyled">
                <a href="https://www.linkedin.com/in/ziao-wang-21a97a157/">Linkedin</a>
              </li>
            </ul>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
      <div className="footer-copyright text-center py-3">
        <MDBContainer fluid>
          &copy; {new Date().getFullYear()} Written by <a href="https://reactjs.org/"> React </a>
        </MDBContainer>
      </div>
    </MDBFooter>
  );
}

class Page extends React.Component {
    render() {
        return ( <div className="grid-container">
            <div className="side"></div>
            <Side />
            <Main />
            <FooterPage />
            </div>
        );
    }
}

ReactDOM.render(<Page />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();